/**
 * GPU picking constants used for entity selection.
 */

/**
 * Integer ID that means the object does not occlude anything for selection picking.
 * Objects with this ID are effectively transparent to picking rays.
 */
export const INTEGER_ID_TRANSPARENT = 1 << 30;

/**
 * Integer ID that means the object does not have an ID, but occludes other objects for selection picking.
 * Used for geometry that should block picking but isn't selectable itself.
 */
export const INTEGER_ID_OCCLUDER = 0;
